/* eslint-disable react-hooks/exhaustive-deps */
import {useState, useEffect} from 'react'
import {Search} from 'lucide-react'
import {initialQueryState, useDebounce} from '../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {TOKENS} from '../../../../../../components/design-system'

const SearchComponent = () => {
  const {updateState} = useQueryRequest()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const debouncedSearchTerm = useDebounce(searchTerm, 150)

  useEffect(() => {
    if (debouncedSearchTerm !== undefined && searchTerm !== undefined) {
      updateState({ search: debouncedSearchTerm, ...initialQueryState })
    }
  }, [debouncedSearchTerm])

  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <Search
        size={14}
        color={TOKENS.color.muted}
        style={{ position: 'absolute', left: 10, pointerEvents: 'none' }}
      />
      <input
        type='text'
        data-kt-user-table-filter='search'
        placeholder='Buscar por ID do log'
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          width: 260,
          padding: '8px 12px 8px 32px',
          fontSize: 13,
          border: `1px solid ${TOKENS.color.border}`,
          borderRadius: TOKENS.radius.chip,
          background: TOKENS.color.card,
          color: TOKENS.color.text,
          outline: 'none',
        }}
      />
    </div>
  )
}

export {SearchComponent}
